module.exports = __webpack_public_path__ + "img/grapholita-molesta.4ad4c514.jpg";